import React from "react";
import Footer from "Component/Footer/Footer";
import Header from "../Component/Header/Header";
import MuseumBanner from "Pages/Museumsubmission/MuseumBg";
import Museumsubmission from "../Pages/Museumsubmission/Museumsubmission";
import Latestupdate from "../Component/Latestupdate/Latestupdate";

export default function Museumregister() {
  return (
    <>
      {/* <Header />
      <MuseumBanner /> */}
      <Museumsubmission />
      {/* <Latestupdate />
      <Footer /> */}
    </>
  );
}
